<div class="flex text-left flex-column modal-cntr">

    <h4 *ngIf="config.data.configuration.label" class="mt-5 mb-5">{{config.data.configuration.label}}</h4>
    <div *ngFor="let item of config.data.configuration.stringList">
        <p class="string-list-modal">{{item}}</p>
    </div>
    <div class="button-cntr mt-4" [ngClass]="config.data.configuration.closable ? 'justify-content-between' : 'justify-content-end'">
        <p-button [icon]="config.data.configuration.iconButton1 || 'pi pi-times'" *ngIf="config.data.configuration.closable" (click)="close()" [label]="config.data.configuration.labelButton1 || 'Annulla'" pAutoFocus [autofocus]="true" [severity]="config.data.configuration.colorbutton1"></p-button>
        <p-button [icon]="config.data.configuration.iconButton2 || 'pi pi-check'" (click)="submit()" [label]="config.data.configuration.labelButton2 || 'Conferma'" pAutoFocus [autofocus]="true" [severity]="config.data.configuration.colorbutton2"></p-button>
    </div>

</div>
